module.exports = __webpack_public_path__ + "img/Bannerbeispiel_Hartschaltenkoffer.07f73e1a.jpg";